import { ActionTypes as types } from 'constants';

export default countryCode => dispatch => {
  dispatch({
    type: types.UPDATE_COUNTRY_CODE,
    payload: countryCode,
  });
};
